module.exports = __webpack_public_path__ + "static/media/productos_cemento.3017ebd6.jpg";